import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { parseBiInsightProposalsWidgetPayload } from '@euler/model/bi/widgets';
import { memo } from 'react';
import { ProposalsCard } from './ProposalsCard';

/**
 * The `bi_insight_proposals` fence: proposal drafts as previews with
 * checkboxes and **Add selected to dashboard**. Ids only; every number
 * comes from the drafts.
 */
export const BiInsightProposalsWidget = memo(({ data }: { data: unknown }) => {
  const payload = parseBiInsightProposalsWidgetPayload(data);
  if (!payload) return <CardNotice text="这组推荐图表无效，请重新提问。" />;
  return <ProposalsCard key={payload.draftIds.join(',')} payload={payload} />;
});
